import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const saveEmailCampaign = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/emails`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const s3PresignedHeaderImageUrl = async (file, fileExtension, fileType) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const s3Response = await axios.get(`${API_URL}/company/emailCampaigns/emails/generateUrl/${fileExtension}/${fileType}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });

    const fullUrl = s3Response.data.url;
    const storedUrl = fullUrl.substring(0, fullUrl.indexOf("?"));
    const uuid = s3Response.data.uuid;

    await axios.put(fullUrl, file, {
        headers: { "Content-Type": file.type }
    });

    return { storedUrl, uuid };
};

export const s3PresignedEmailAttachmentUrl = async (file, fileExtension, fileType) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const s3Response = await axios.get(`${API_URL}/company/emailCampaigns/emails/attachment/generateUrl/${fileExtension}/${fileType}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });

    const fullUrl = s3Response.data.url;
    const storedUrl = fullUrl.substring(0, fullUrl.indexOf("?"));
    const uuid = s3Response.data.uuid;

    await axios.put(fullUrl, file, {
        headers: { "Content-Type": file.type }
    });

    return { storedUrl, uuid };
};

export const resendEmailCampaign = async (campaignUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);

    const response = await axios.post(`${API_URL}/company/emailCampaigns/emails/resend/${campaignUuid}`, {},
        {
            headers: {
                Authorization: "Bearer " + token,
            },
        }
    );

    return response.data;
};

export const purchaseNewCap = async (addonUuid, paymentMethodId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);

    const response = await axios.post(
        `${API_URL}/company/airwallex/purchaseNow/purchaseAddOn`,
        { addonUuid, paymentMethodId },
        {
            headers: {
                Authorization: "Bearer " + token,
            },
        }
    );

    return response.data;
};